import CreateFolderModal from './CreateFolderModal';

export default CreateFolderModal;
